import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { type CompanyDetail, companyFromServer } from 'models/company-model'
import { get, patch } from 'utils/http'

// Company detail; companyFromServer maps the raw company to { company, ipRanges } (camelCase working shape).
export const useCompany = (uuid: any) =>
  useQuery({
    queryKey: ['company', uuid],
    queryFn: async (): Promise<CompanyDetail> => companyFromServer(await get(`/management/companies/${uuid}/`)),
    enabled: !!uuid,
  })

// Website-only PATCH; mirrors the old updateCompany notifications, then refetches.
export const useUpdateCompany = () => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  return useMutation({
    mutationFn: async ({ uuid, url }: any) => {
      try {
        await patch(`/management/companies/${uuid}`, { url })
        addNotification(
          'Website saved. Changes will be applied after recalc. To apply immediately, create and approve a change request.',
          'success',
        )
        queryClient.invalidateQueries({ queryKey: ['company', uuid] })
        return true
      } catch {
        addNotification('Failed to update website', 'error')
        return false
      }
    },
  })
}
